import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function resolveValue(valueOrFn, token) {
  return typeof valueOrFn === 'function' ? valueOrFn({
    token: token
  }) : valueOrFn;
}

function styles(_ref) {
  var target = _ref.target,
      fallback = _ref.fallback,
      property = _ref.property,
      duration = _ref.duration,
      easing = _ref.easing,
      delay = _ref.delay;
  return {
    transitionProperty: function transitionProperty(_ref2) {
      var token = _ref2.token;
      return property !== null && property !== void 0 ? property : token("".concat(target, ".transition.property"), token("transition.simple.".concat(fallback, ".property")));
    },
    transitionDuration: function transitionDuration(_ref3) {
      var _ref4, _token;

      var token = _ref3.token;
      return "".concat((_ref4 = (_token = token("duration.".concat(duration))) !== null && _token !== void 0 ? _token : resolveValue(duration, token)) !== null && _ref4 !== void 0 ? _ref4 : token("".concat(target, ".transition.duration"), token("transition.simple.".concat(fallback, ".duration"), token('duration.medium'))), "ms");
    },
    transitionTimingFunction: function transitionTimingFunction(_ref5) {
      var _ref6, _token2;

      var token = _ref5.token;
      return (_ref6 = (_token2 = token("easing.".concat(easing))) !== null && _token2 !== void 0 ? _token2 : resolveValue(easing, token)) !== null && _ref6 !== void 0 ? _ref6 : token("".concat(target, ".transition.timingFunction"), token("transition.simple.".concat(fallback, ".timingFunction"), token('easing.linear')));
    },
    transitionDelay: function transitionDelay(_ref7) {
      var _ref8, _token3;

      var token = _ref7.token;
      return "".concat((_ref8 = (_token3 = token("duration.".concat(delay))) !== null && _token3 !== void 0 ? _token3 : resolveValue(delay, token)) !== null && _ref8 !== void 0 ? _ref8 : token("".concat(target, ".transition.delay"), token('duration.immediate')), "ms");
    }
  };
}

styles.combine = function (_ref9) {
  var target = _ref9.target,
      _ref9$presets = _ref9.presets,
      presets = _ref9$presets === void 0 ? [] : _ref9$presets;

  var presetStyles = _mapInstanceProperty(presets).call(presets, function (preset) {
    return styles(_objectSpread({
      target: target
    }, preset));
  });

  return {
    transitionProperty: function transitionProperty(_ref10) {
      var token = _ref10.token;
      return _mapInstanceProperty(presetStyles).call(presetStyles, function (preset) {
        var _preset$transitionPro;

        return (_preset$transitionPro = preset.transitionProperty) === null || _preset$transitionPro === void 0 ? void 0 : _preset$transitionPro.call(preset, {
          token: token
        });
      }).join(',');
    },
    transitionDuration: function transitionDuration(_ref11) {
      var token = _ref11.token;
      return _mapInstanceProperty(presetStyles).call(presetStyles, function (preset) {
        var _preset$transitionDur;

        return (_preset$transitionDur = preset.transitionDuration) === null || _preset$transitionDur === void 0 ? void 0 : _preset$transitionDur.call(preset, {
          token: token
        });
      }).join(',');
    },
    transitionTimingFunction: function transitionTimingFunction(_ref12) {
      var token = _ref12.token;
      return _mapInstanceProperty(presetStyles).call(presetStyles, function (preset) {
        var _preset$transitionTim;

        return (_preset$transitionTim = preset.transitionTimingFunction) === null || _preset$transitionTim === void 0 ? void 0 : _preset$transitionTim.call(preset, {
          token: token
        });
      }).join(',');
    },
    transitionDelay: function transitionDelay(_ref13) {
      var token = _ref13.token;
      return _mapInstanceProperty(presetStyles).call(presetStyles, function (preset) {
        var _preset$transitionDel;

        return (_preset$transitionDel = preset.transitionDelay) === null || _preset$transitionDel === void 0 ? void 0 : _preset$transitionDel.call(preset, {
          token: token
        });
      }).join(',');
    }
  };
};

export var transition = {
  styles: styles
};